import { createReducer, Action, on } from '@ngrx/store';
import { IProductState, EProductStateStatus } from '../models/product.model';
import {
  loadProducts,
  loadProductsSuccess,
  loadProductsError,
  createProducts,
  createProductsSuccess,
  createProductsError,
  updateProducts,
  updateProductsSuccess,
  updateProductsError,
  deleteProducts,
  deleteProductsSuccess,
  deleteProductsError,
} from '../actions/product.action';

const initialState: IProductState = {
  products: [],

  status: EProductStateStatus.INITIALIZING,
  error: null,
  pagination: {
    current_page: 0,
    has_more_data: false,
    has_previous: false,
    page_size: 10,
    total_pages_count: 0,
  },
};

const productReducer = createReducer(
  initialState,
  on(loadProducts, (state, { pagination }) => {
    return {
      ...state,
      error: null,
      status: EProductStateStatus.LOADING,
      pagination: {
        ...state.pagination,
        pagination,
      },
    };
  }),
  on(loadProductsSuccess, (state, { products, pagination }) => {
    return {
      ...state,
      status: EProductStateStatus.READY,
      products,
      pagination,
    };
  }),
  on(loadProductsError, (state, { error }) => {
    return {
      ...state,
      state: EProductStateStatus.ERROR,
      error,
    };
  }),
  on(createProducts, (state, {}) => {
    return {
      ...state,
      status: EProductStateStatus.LOADING,
      pagination: {
        ...state.pagination,
      },
    };
  }),
  on(createProductsSuccess, (state, {}) => {
    return {
      ...state,
      status: EProductStateStatus.UPDATED,
    };
  }),
  on(createProductsError, (state, { error }) => {
    return {
      ...state,
      status: EProductStateStatus.ERROR,
      error,
    };
  }),
  on(updateProducts, (state, {}) => {
    return {
      ...state,
      status: EProductStateStatus.LOADING,
      pagination: {
        ...state.pagination,
      },
    };
  }),
  on(updateProductsSuccess, (state, {}) => {
    return {
      ...state,
      status: EProductStateStatus.UPDATED,
    };
  }),
  on(updateProductsError, (state, { error }) => {
    return {
      ...state,
      status: EProductStateStatus.ERROR,
      error,
    };
  }),
  on(deleteProducts, (state, {}) => {
    return {
      ...state,
      status: EProductStateStatus.LOADING,
      pagination: {
        ...state.pagination,
      },
    };
  }),
  on(deleteProductsSuccess, (state, {}) => {
    return {
      ...state,
      status: EProductStateStatus.UPDATED,
    };
  }),
  on(deleteProductsError, (state, { error }) => {
    return {
      ...state,
      status: EProductStateStatus.ERROR,
      error,
    };
  })
);

export function reducer(state: IProductState, action: Action) {
  return productReducer(state, action);
}
